import React from 'react';
import classNames from 'classnames';
import { ValueContainerProps, components } from 'react-select';
import { SelectOption } from '../../..';

const Component = components.ValueContainer;

const TransparentValueContainer = (
  props: ValueContainerProps<SelectOption>,
) => {
  const selectedOption: SelectOption = props.getValue()[0]; // Gets selected value (array)

  return (
    <Component {...props} className={classNames('flex align-items-center')}>
      <h1 className='m-0 text-truncate' title={selectedOption.label}>
        {selectedOption.label}
      </h1>
      <div className='position-absolute'>{props.children}</div>
    </Component>
  );
};

export default TransparentValueContainer;
